import { z } from 'zod';
import type { AuthPageCopy } from '@/i18n/auth-page-copy';

type PasswordResetSchemaCopy = Pick<
  AuthPageCopy,
  | 'emailValidation'
  | 'passwordResetMinimumValidation'
  | 'confirmPasswordValidation'
  | 'passwordsDoNotMatch'
>;

export function createPasswordResetRequestSchema(
  copy: PasswordResetSchemaCopy
) {
  return z.object({ email: z.string().email(copy.emailValidation) });
}

export type PasswordResetRequestForm = z.infer<
  ReturnType<typeof createPasswordResetRequestSchema>
>;

export function createPasswordResetSchema(copy: PasswordResetSchemaCopy) {
  return z
    .object({
      password: z.string().min(8, copy.passwordResetMinimumValidation),
      confirmPassword: z.string().min(8, copy.confirmPasswordValidation),
    })
    .refine((data) => data.password === data.confirmPassword, {
      path: ['confirmPassword'],
      message: copy.passwordsDoNotMatch,
    });
}

export type PasswordResetFormValues = z.infer<
  ReturnType<typeof createPasswordResetSchema>
>;
